import { EcommerceAPI, MagicAPI } from "../Client";

export const getCustomerApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/api/customer?customerId=${payload?.customerId || 0}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCustomersApi = async (payload) => {
  try {
  const params = new URLSearchParams({
  page: String(payload?.page ?? 0),
  size: String(payload?.size ?? 10),
  search: payload?.search ?? "",
  sortBy: payload?.sortby ?? "",
  sortDir: payload?.sortdir ?? "",
  qrCustomer:
    payload?.qrCustomer === true
      ? "true"
      : payload?.qrCustomer === false
      ? "false"
      : "",
});

const response = await EcommerceAPI.get(`/api/customers?${params.toString()}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCustomerApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/api/customer`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCustomerApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/api/customer`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCustomerMindApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/api/customer/mind`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadMagicArOutputApi = async ({
  customerId,
  videoMapId,
  files = [],
  frameShape,
}) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  const params = { customerId, videoMapId };
  if (frameShape !== null && typeof frameShape !== "undefined") {
    params.frameShape = frameShape;
  }

  return MagicAPI.post("/magic/v1/image/aroutput/upload", formData, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

